import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { Subscription } from 'rxjs';
import { finalize } from 'rxjs/operators';
import { Language } from '../../shared/model';
import { SharedService } from '../../shared/shared.service';

@Component({
  selector: 'app-first-and-half-step',
  templateUrl: './first-and-half-step.component.html',
  styleUrls: ['./first-and-half-step.component.css']
})
export class FirstAndHalfStepComponent implements OnInit, OnDestroy {
  @Output() change: EventEmitter<boolean> = new EventEmitter();

  public allLanguages: Array<Language>;
  public selectedLanguage: Language = <Language>{};

  subscriptions = new Subscription();

  constructor(private sharedService: SharedService) { }

  ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }

  ngOnInit(): void {
    this.subscriptions.add(
      this.sharedService.getLanguages()
      .pipe(finalize(() => {
        this.allLanguages = this.allLanguages.filter(language => language.LanguageCode.toString() !== 'en');
      }))
      .subscribe((result) => {
        this.allLanguages = result;
      })
    )
  }

  languageChange(event): void {
    this.subscriptions.add(
      this.sharedService.setLanguageIndicator()
      .pipe(finalize(() => {
        const selectedLanguage: Language = <Language>{
          Id: event.Id,
          Name: event.Name,
          LanguageCode: event.LanguageCode
        };
  
        this.sharedService.setCurrentLanguage(selectedLanguage);
        window.location.reload();
      }))
      .subscribe()
    );
  }

  onButtonMeetingInEnglishClick(): void {
    this.subscriptions.add(
      this.sharedService.setLanguageIndicator()
      .pipe(finalize(() => {
        this.change.emit(true);
      }))
      .subscribe()
    );
  }
}
